export default __webpack_public_path__ + "static/media/line.726e91b6.svg";